import  { createContext, useState, useEffect, useCallback, useRef} from 'react';
import {checkReport, removeHash} from '../api/Common/report'
import Moment from 'moment';
import { useAuth } from '../hooks';
import { getPermissions } from '../components/Common';
import { STORAGE_KEYS, TIMEOUTS, DATE_FORMATS } from '../utils/constantes';
export const NotificationContext = createContext({
  showNotification :()=>null,
  hiddenNotification:()=>null,
  checkReportStatus:()=>null,
  startInterval:()=>null
});
Moment.locale('en');
export const NotificationProvider = ({ children }) => {
    const {auth} = useAuth()
    const [lastNotificationInfo, setLastNotificationInfo] = useState(null);
    const intervalIdRef = useRef(null);

    const addNotificationData = useCallback((url) => {
        let notificationData = localStorage.getItem(STORAGE_KEYS.NOTIFICATION_DATA);

    
        // Si hay datos almacenados, conviértelos de cadena a array
        let parsedData = notificationData === null ? [] :  JSON.parse(notificationData);
       
        // Agrega el nuevo elemento al array
        parsedData.push({'fecha': Moment(Date()).format(DATE_FORMATS.NOTIFICATION), 'url': url,'show':false});
        
    
        // Actualiza el array convertido a cadena en localStorage
        localStorage.setItem(STORAGE_KEYS.NOTIFICATION_DATA, JSON.stringify(parsedData));
    
    }, []);
   
    const checkReportStatus = useCallback(async () => {

		if(getPermissions("generate_report",auth)){
        const hashData = localStorage.getItem(STORAGE_KEYS.HASH);
        if (hashData === null || JSON.parse(hashData).length === 0 ) {
              if(intervalIdRef.current) {
                  clearInterval(intervalIdRef.current);
              }
          return false;
        }

        try {
          const hashes = JSON.parse(hashData);
          await Promise.all(hashes.map(async hash=>{
            const response = await checkReport(hash);
            const data     = await response.json();

            if (data.filename !== undefined) {
              addNotificationData(data.filename)
              setLastNotificationInfo({'fecha': Moment(Date()).format(DATE_FORMATS.NOTIFICATION), 'url': data.filename,'show':false});
              
              if(intervalIdRef.current) {
                  clearInterval(intervalIdRef.current); // Detener el intervalo al obtener la URL
              }
              
              removeHash(hash)
          
            }else{
              return false;
            }
          }))
            
                
            
          
        } catch (error) {
            console.error('Error al verificar el estado del informe:', error);
            if(intervalIdRef.current) {
                clearInterval(intervalIdRef.current); 
            }
                //localStorage.removeItem(STORAGE_KEYS.HASH)
        }
    }
		
	  }, [auth, addNotificationData]);
  
    const hiddenNotification = useCallback(()=>{
        setLastNotificationInfo(false)
    }, []);

    const startInterval = useCallback(()=>{
        if(intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
        }

        const intervalId = setInterval(() => {checkReportStatus();}, TIMEOUTS.NOTIFICATION_CHECK_INTERVAL);
        intervalIdRef.current = intervalId;
        localStorage.setItem(STORAGE_KEYS.INTERVAL_ID, intervalId.toString())
        // Limpia el intervalo al desmontar el componente
        return intervalId
    }, [checkReportStatus]);

	useEffect(() => {
		const intervalId = startInterval()
		return () => {
            if(intervalIdRef.current) {
                clearInterval(intervalIdRef.current);
            }
		};
	}, [startInterval]); 

  const valueContext = {
    checkReportStatus,
    lastNotificationInfo,
    hiddenNotification,
    startInterval
}
  return (
    <NotificationContext.Provider value={valueContext}>
      {children}
    </NotificationContext.Provider>
  );
};

